import { create } from "zustand";

const INITIAL_PARAMS = {
  page: 1,
  size: 10,
  code: "",
  name: "",
  store_code: "",
  group_code: "",
};

export const useDMTKFiltersStore = create((set) => ({
  params: INITIAL_PARAMS,
  search: (newParams) =>
    set((state) => ({ params: { ...state.params, ...newParams, page: 1 } })),
  changePage: (newPage) =>
    set((state) => ({ params: { ...state.params, page: newPage } })),
  changeLimit: (newLimit) =>
    set((state) => ({ params: { ...state.params, size: newLimit, page: 1 } })),
}));
